import DataVisualizationChartCardView from './ChartCard'

export const ChartCard = DataVisualizationChartCardView

export default DataVisualizationChartCardView
